import React from 'react'
import ReactGA from 'react-ga'
import Firebase from 'firebase'

import SecretWindow from './SecretWindow'

class SecretWindowContainer extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      open: false,
    }
  }

  _onTouchStart = () => {
    ReactGA.event({
      category: 'Game',
      action: 'Opened the secret word/target window',
    })
    this.setState({
      open: true,
    })
  }

  _onTouchEnd = () => {
    this.setState({
      open: false,
    })
  }

  render = () => {

    let getPlayerFromID = id => {
      return this.props.players.find(p => p.user === id)
    }

    let getTargetOfPlayer = id => {
      let player = getPlayerFromID(id)
      let target = getPlayerFromID(player.target)
      if (target.alive) {
        return target
      } else {
        return getTargetOfPlayer(target.user)
      }
    }

    const target = getTargetOfPlayer(Firebase.auth().currentUser.uid)

    return <SecretWindow
      onTouchStart={this._onTouchStart}
      onTouchEnd={this._onTouchEnd}
      target={target}
      open={this.state.open}
      />
  }

}

export default SecretWindowContainer



// WEBPACK FOOTER //
// ./src/views/game/components/SecretWindowContainer.jsx